import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

const _hoisted_3 = {
  key: 0,
  class: "base_main_header"
};
const _hoisted_4 = {
  key: 1,
  class: "base_main_margin_top"
};
import StatusBar from "@com/StatusBar.vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import CancelOrder from "@com/order/CancelOrder.vue";
import { OP_KEY, COLUMN_TYPE, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { $msg, $box } from "@ui/msg";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import $ from "@util/base";
import configApi from "@api/config";
import api from "@api/order";
export default {
  __name: 'LineOrder',
  props: {
    type: {
      type: String
    },
    routeName: {
      type: String
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    route.watchRouter(props.routeName, () => {
      getData();
    });
    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "预定中",
      value: "1058001",
      total: 0
    }, {
      label: "预定成功",
      value: "1058002",
      total: 0
    }, {
      label: "预定取消",
      value: "fail",
      total: 0
    }]);
    const baseOptions = ref([]);
    const base = ref(route.query().base || "");
    const main = ref(route.query().main || "");
    const orderCode = ref(route.query().orderCode || "");
    const name = ref(route.query().name || "");
    const date = ref(route.query().date || []);
    const total = ref(0);
    const data = ref([]);
    getConfig();

    function getConfig() {
      configApi.base(val => {
        baseOptions.value = val;
      });
    }

    function lineOperations(data) {
      if (props.type == "order") {
        // 1058001 预定中 1058002 预定成功 1058003 用户取消预定 1058004 后台取消预定
        switch (data.orderStatus) {
          case "1058001":
            // 处理中
            return [OPERATIONS.docking];

          case "1058005":
            return [OPERATIONS.cancelOrder, OPERATIONS.confirmOrder];

          default:
            return [];
        }
      } else {
        return [];
      }
    }

    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 130,
        operations: lineOperations
      },
      column: [// {
      //   label: "主订单编号",
      //   prop: "mainOrderCode",
      //   width: 110,
      // },
      {
        label: "订单编号",
        prop: "orderCode",
        width: 120
      }, {
        label: "线路名称",
        prop: "lineName",
        width: 160
      }, {
        label: "线路规格",
        prop: "lineAttr",
        width: 180,
        type: COLUMN_TYPE.tooltip,
        rows: 3
      }, {
        label: "线路区域",
        prop: "lineArea",
        width: 120
      }, {
        label: "线路类型",
        prop: "lineType",
        width: 120
      }, // {
      //   label: "预定人（平台昵称）",
      //   prop: "memberName",
      //   width: 120,
      // },
      {
        label: "用户账户",
        prop: "phone",
        width: 120
      }, {
        label: "对接人",
        prop: "contactPerson",
        width: 120
      }, {
        label: "出发时间",
        prop: "setOutTime",
        width: 120
      }, {
        label: "联系电话",
        prop: "contactPhone",
        width: 140
      }, {
        label: "预定公司",
        prop: "companyName",
        width: 120
      }, {
        label: "人数",
        prop: "num",
        width: 90
      }, {
        label: "对接人",
        prop: "dockingUser",
        width: 90
      }, {
        label: "处理状态",
        prop: "orderStatusStr",
        width: 120
      }]
    };
    let selectOpData = null;
    const opHander = operationsHander();
    opHander.install(OP_KEY.cancelOrder, data => {
      $box.open("取消订单", "是否取消订单？", () => {
        api.confirmOrder(data.orderCode, "1058004", () => {
          $msg.succ("取消成功");
          getData();
        }, msg => {
          $box.open("取消失败", msg);
        });
      });
    });
    opHander.install(OP_KEY.confirmOrder, data => {
      $box.open("确认订单", "是否确认订单？", () => {
        api.confirmOrder(data.orderCode, "1058002", () => {
          $msg.succ("确认成功");
          getData();
        }, msg => {
          $box.open("确认失败", msg);
        });
      });
    });
    opHander.install(OP_KEY.docking, data => {
      $box.open("对接介入", "是否对接介入？", () => {
        api.confirmOrder(data.orderCode, "1058005", () => {
          $msg.succ("确认成功");
          getData();
        }, msg => {
          $box.open("确认失败", msg);
        });
      });
    });

    function searchBase(val) {
      route.replaceQuery("base", val);
    }

    function searchOrderCode(val) {
      route.replaceQuery("orderCode", val);
    }

    function searchName(val) {
      route.replaceQuery("name", val);
    }

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    getData();

    function getData() {
      getNum();
      getList();
    }

    function getNum() {
      let routeQuery = route.query();
      let params = {
        memberLoginName: routeQuery.login,
        shopCode: routeQuery.base,
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        hotelName: routeQuery.hotel,
        guestName: routeQuery.name,
        status: routeQuery.status
      };

      if ($.isNotEmpty(routeQuery.date)) {
        params.startTime = routeQuery.date[0];
        params.endTime = routeQuery.date[1];
      }

      api.num(params, "line", val => {
        statusData([val.total, val.inProgress, val.success, val.cancel]);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function getList() {
      let routeQuery = route.query();
      let params = {
        type: "line",
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        status: routeQuery.status,
        hotelName: routeQuery.hotel,
        guestName: routeQuery.name,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s
      };
      api.orderList(params, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          switch (e.orderStatus) {
            case "1058001":
              e.status = "预定中";
              break;

            case "1058002":
              e.status = "预定成功";
              break;

            case "1058003":
              e.status = "用户取消预定";
              break;

            case "1058004":
              e.status = "后台取消预定";
              break;
          }

          return e;
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        inline: true,
        class: "base_search_form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => date.value = $event),
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "value-format": "YYYY-MM-DD",
            onChange: searchDate
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: orderCode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderCode.value = $event),
            "onKeyup[native]": searchOrderCode,
            onChange: searchOrderCode,
            placeholder: "订单编号",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => name.value = $event),
            "onKeyup[native]": searchName,
            onChange: searchName,
            placeholder: "预定人",
            clearable: "",
            "suffix-icon": _unref(Search)
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(StatusBar, {
        data: statusList,
        default: "all"
      }, null, 8, ["data"]), props.type == 'order' ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createVNode(DataCollectTable, {
        data: data.value,
        total: total.value,
        config: config,
        onOperationsHander: _unref(opHander).receive
      }, null, 8, ["data", "total", "onOperationsHander"])]);
    };
  }

};